import {Button} from "@dv5/components"
import {DvViewItemType} from '@dv5/domain'
import React, {FC, useEffect, useRef, useState} from 'react'
import './AddItemDialog.less'

interface AddItemDialogProps {
    onAdd: (title: string, itemType: DvViewItemType) => void
    onCancel: () => void
}

export const AddItemDialog: FC<AddItemDialogProps> = ({onAdd, onCancel}) => {
    const dialogRef = useRef<HTMLDivElement>(null)
    const [title, setTitle] = useState('')
    const [itemType, setItemType] = useState<DvViewItemType>(DvViewItemType.LINK)
    const inputRef = useRef<HTMLInputElement>(null)

    useEffect(() => {
        inputRef.current?.focus()
    }, [])

    const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
        if (dialogRef.current && !dialogRef.current.contains(e.target as Node)) {
            onCancel()
        }
    }
    const checkIfSubmitAvailable = () => {
        if (itemType === DvViewItemType.VIEW_LINK) {
            console.error('Not implemented yet')
        } else {
            handleSubmit()
        }
    }

    const handleKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter') {
            checkIfSubmitAvailable()
        } else if (e.key === 'Escape') {
            onCancel()
        }
    }

    const handleSubmit = () => {
        if (title.trim()) {
            onAdd(title.trim(), itemType)
        }
    }

    return (
        <div className="add-item-dialog-overlay" onClick={handleOverlayClick}>
            <div className="add-item-dialog" ref={dialogRef} onKeyDown={handleKeyDown}>
                <h3 className="add-item-dialog-title">Add Item to Pocket</h3>
                <div className="add-item-dialog-content">
                    <div className="add-item-dialog-field">
                        <label htmlFor="item-title">Title</label>
                        <input
                            id="item-title"
                            ref={inputRef}
                            type="text"
                            className="add-item-dialog-input"
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                            placeholder="Enter item title"
                        />
                    </div>
                    <div className="add-item-dialog-field">
                        <label htmlFor="item-type">Item Type</label>
                        <select
                            id="item-type"
                            className="add-item-dialog-select"
                            value={itemType}
                            onChange={(e) => setItemType(e.target.value as DvViewItemType)}
                        >
                            <option value={DvViewItemType.LINK}>Link</option>
                            <option value={DvViewItemType.VIEW_LINK}>View Link</option>
                            <option value={DvViewItemType.DOCUMENT}>Document</option>
                            <option value={DvViewItemType.CANVAS}>Canvas</option>
                            <option value={DvViewItemType.HINT}>Hint</option>
                            <option value={DvViewItemType.STOP_WATCH}>Stop Watch</option>
                        </select>
                    </div>
                </div>
                <div className="add-item-dialog-buttons">
                    <Button
                        title="Add"
                        onClick={checkIfSubmitAvailable}
                        className="add-item-dialog-add-btn"
                    />
                    <Button
                        title="Cancel"
                        onClick={onCancel}
                        className="add-item-dialog-cancel-btn"
                    />
                </div>
            </div>
        </div>
    )
}
